"use strict";

export const isAutoGuruSlug = slug => {
  return slug === 'autoguru';
};